import axios from "axios";

// 8s default keeps SSR responsive (NEXTJS-55: 30s timeouts on
// /api/event-gallery left users staring at a blank page long after they'd
// abandoned). Long-running calls like file uploads override per-request.
const instance = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  withCredentials: true,
  timeout: 8000,
  maxContentLength: Infinity,
});

// instance.interceptors.request.use(
//   async function (config) {
//     if (typeof window !== "undefined") {
//       await instance.get(
//         `${process.env.NEXT_PUBLIC_API_URL}/sanctum/csrf-cookie`
//       );
//     }
//     return config;
//   },
//   function (error) {
//     // Do something with request error
//     return Promise.reject(error);
//   }
// );

export default instance;
